export const clientId = 'cus-MTYyNzY0ODkzMTE0NGszdXlt';
export const secretKey =
  '0653d9f4cdff4de5edbb6b22cd2d5f3b:6b0436eca2e69575d638f13d216c61579849ecb114f41ff836497f58e2eea069';
